export const POLL_CONFIGURATION_PLACEHOLDER = {
  satisfaction: 'Ex. Satisfação',
  reservation: 'Ex. Reserva',
}
